var home = (function ($) {

  var selectors = {
    document: document,
    slider: '#homeSlider',
    navbar: '.banner'
  };
  var nodes;

  function heroSlider() {
    nodes.slider.slick({
      infinite: true,
      dots: true,
      arrows: false,
      slidesToShow: 1,
      lazyLoad: 'ondemand',
      autoplay: true
    });
  }

  function fixNavigation() {
    nodes.navbar.addClass('fixed-top');
  }

  return {
    init: function () {
      nodes = utils.createNodes(selectors);
      heroSlider();
      fixNavigation();
    }
  };

})(jQuery);
